import { Tag, Typography } from "antd";
// import { ArrowRight } from "lucide-react";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Util } from "../../treasury/treasuryBill/helper/helper";

const { Text, Link, Title, Paragraph } = Typography;

export default function PreviewTable({ data }) {
  return (
    <div
      style={{
        border: "1px solid #E5E7EB",
        borderRadius: 16,
        overflow: "hidden",
        boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)",
        backgroundColor: "#FFFFFF",
      }}
    >
      {data?.map((item, i) => {
        return (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              borderBottom: i !== data.length - 1 ? "1px solid #F3F4F6" : "0",
              transition: "background-color 0.2s ease",
              minHeight: "60px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#F9FAFB";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
            }}
          >
            {/* Title Section */}
            <div
              style={{
                flex: "0 0 40%",
                padding: "16px 24px",
                backgroundColor: "#F8FAFC",
                borderRight: "1px solid #E5E7EB",
                fontWeight: "600",
                fontSize: "14px",
                color: "#374151",
                lineHeight: "1.4",
                display: "flex",
                alignItems: "center",
                minHeight: "60px",
              }}
            >
              <span style={{ wordBreak: "break-word" }}>{item.name}</span>
            </div>

            {/* Arrow Section */}
            <div
              style={{
                flex: "0 0 60px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#FFFFFF",
              }}
            >
              <ArrowRightOutlined
                size={16}
                style={{
                  color: "#6B7280",
                  opacity: 0.7,
                }}
              />
            </div>

            {/* Value Section */}
            <div
              style={{
                flex: "1",
                padding: "16px 24px 16px 0",
                display: "flex",
                alignItems: "center",
                minHeight: "60px",
              }}
            >
              <Text
                style={{
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#111827",
                  lineHeight: "1.4",
                  wordBreak: "break-word",
                }}
              >
                {item?.prefix && (
                  <span style={{ color: "#6B7280", marginRight: "4px" }}>
                    {item.prefix}
                  </span>
                )}
                <span style={{ color: "#111827" }}>
                  {Util.capitalizeFirstLetter(item?.labelValue)}
                </span>
                {item?.suffix && (
                  <span style={{ color: "#6B7280", marginLeft: "4px" }}>
                    {item.suffix}
                  </span>
                )}
              </Text>
            </div>
          </div>
        );
      })}
    </div>
  );
}
